import { Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import checkedIcon from "../../assets/icons/switchText.svg";
import disabledIcon from "../../assets/icons/switchTextII.svg";

const CustomSwitchText = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))({
  width: "288px",
  height: 50,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    height: 40,
    padding: 0,
    margin: 0,
    transitionDuration: "200ms",
    "&.Mui-checked": {
      transform: "translateX(137px)",
      color: "#1492AF",
      "& .MuiSwitch-thumb": {
        backgroundImage: `url("${checkedIcon}")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize:'contain',
        color: "#1492AF",
      },
      "& + .MuiSwitch-track": {
        backgroundColor: "#D4EDF3",
        opacity: 1,
        height: 40,
        width: 288,
        backgroundImage: `url("${disabledIcon}")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "left",
        backgroundSize:'contain',
        
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        height: 40,
        width: 288,
        opacity: 0.5,
        backgroundColor: "#E7E9EF"
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: "150px",
    height: "40px",
    color: "#1492AF",
    borderRadius: 100,
    backgroundImage: `url("${disabledIcon}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize:'contain',
  },
  "& .MuiSwitch-track": {
    width: 288,
    height: 40,
    borderRadius: "100px",
    backgroundColor: "#D4EDF3",
    opacity: 1,
    backgroundImage: `url("${checkedIcon}")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right",
    backgroundSize:'contain',
  },
});

export default CustomSwitchText;
